"use strict";

var _slicedToArray = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var ContentContainer = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // force this to be a new Block Formatting Context to contain\n  // margins that the children might set.\n  /* https://developer.mozilla.org/en-US/docs/Web/Guide/CSS/Block_formatting_context */\n  display: flow-root;\n"])));

var Expander = function Expander(_ref) {
  var open = _ref.open,
      children = _ref.children,
      _ref$floating = _ref.floating,
      floating = _ref$floating === void 0 ? false : _ref$floating,
      _ref$animDuration = _ref.animDuration,
      animDuration = _ref$animDuration === void 0 ? 250 : _ref$animDuration,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style;
  // persist animation timer reference across renders to handle animation cancelling
  var animTimer = react_1.default.useRef(); // ref for measuring the height of the content inside the section

  var contentContainer = react_1.default.useRef(null); // rendering children or not is differnet from the open and close status
  // of the expander because they need to render before the animation starts
  // to open and stop rendering only after the animation finishes closing.
  // not rendering children while the expander is closed is important for
  // both performance and accessibility (takes invisible things out of the tree)

  var _ref2 = (0, react_1.useState)(open !== null && open !== void 0 ? open : false),
      _ref3 = _slicedToArray(_ref2, 2),
      renderChildren = _ref3[0],
      setRenderChildren = _ref3[1]; // height of the collapsing section which animates to hide / reveal children


  var _ref4 = (0, react_1.useState)(open ? 'auto' : 0),
      _ref5 = _slicedToArray(_ref4, 2),
      hiderHeight = _ref5[0],
      setHiderHeight = _ref5[1]; // layout effect to handle state changes
  // relative to all possible current statuses,
  // and handle DOM measurement when necessary


  (0, react_1.useLayoutEffect)(function () {
    // Extra SSR safety
    if (typeof window === 'undefined') return; // if expander is closed and needs to be open

    if (open && hiderHeight === 0) {
      // reset timer to interupt current animation
      if (animTimer.current) clearTimeout(animTimer.current); // render children in so we can measure height

      setRenderChildren(true);
      window.requestAnimationFrame(function () {
        var _a; // measure and set animatable height


        setHiderHeight((_a = contentContainer.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height); // at the end of the animation, set the height
        // to auto so that it will adjust properly when
        // the window resizes

        animTimer.current = setTimeout(function () {
          setHiderHeight('auto');
        }, animDuration);
      });
    } // if expander is open and needs to be closed


    if (!open && hiderHeight === 'auto') {
      // reset timer to interupt current animation
      if (animTimer.current) clearTimeout(animTimer.current); // using nested requestAnimationFrame here so that
      // react absolutely has to run these steps separate
      // render cycles (can't optimize this state change).

      window.requestAnimationFrame(function () {
        var _a; // can't animate "auto" so measure and set current height


        setHiderHeight((_a = contentContainer.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height); // set the height to 0 one frame after the
        // height is rendered into the DOM

        window.requestAnimationFrame(function () {
          setHiderHeight(0); // remove the children at the end of the animation

          animTimer.current = setTimeout(function () {
            setRenderChildren(false);
          }, animDuration);
        });
      });
    }
  }, [open, hiderHeight, animDuration]);
  return react_1.default.createElement("div", {
    style: Object.assign(Object.assign({
      height: hiderHeight,
      overflow: hiderHeight === 'auto' ? 'visible' : 'hidden',
      transition: "".concat(animDuration, "ms ease")
    }, floating && {
      borderBottomRightRadius: 5,
      borderBottomLeftRadius: 5,
      background: 'white',
      position: 'absolute',
      boxShadow: '0px 15px 30px -10px rgba(0, 0, 0, 0.25)'
    }), style)
  }, react_1.default.createElement(ContentContainer, {
    ref: contentContainer
  }, renderChildren && children));
};

exports.default = Expander;